import {afterNextRender, Component, DestroyRef, ElementRef, inject, viewChild} from '@angular/core';
import {SchemeFacade} from '../application/scheme.facade';
import {SchemeCard} from '../ui/scheme-card/scheme-card';
import {SearchFacade} from '../../search/application/search.facade';
import {MatGridList, MatGridTile} from '@angular/material/grid-list';
import {MatChip, MatChipSet} from '@angular/material/chips';
import {FacetKey, FacetNode, FacetNodeType} from '../../search/domain/search.model';

@Component({
  selector: 'app-scheme-page',
  imports: [
    SchemeCard,
    MatGridList,
    MatGridTile,
    MatChipSet,
    MatChip
  ],
  templateUrl: './scheme-page.html',
  styleUrl: './scheme-page.scss',
})
export class SchemePage {
  private readonly _schemeFacade = inject(SchemeFacade);
  private readonly _searchFacade = inject(SearchFacade);
  private readonly _destroyRef = inject(DestroyRef);

  private readonly _sentinel = viewChild.required<ElementRef<HTMLElement>>('sentinel');

  protected readonly scheme = this._schemeFacade.scheme;
  protected readonly schemes = this._searchFacade.schemes;
  protected readonly totalSchemesCount = this._searchFacade.totalSchemesCount;
  protected readonly facetKeys = Object.values(FacetKey);
  protected readonly activeFilters = this._searchFacade.activeFilters;
  protected readonly hasActiveFilters = this._searchFacade.hasActiveFilters;
  protected readonly levelLabels: Record<string, string> = {
    area: 'Bereich',
    group: 'Gruppe',
    name: 'Produkt',
  };

  constructor() {
    afterNextRender(() => {
      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this._searchFacade.searchNext();
          }
        },
        { threshold: 0 }
      );
      observer.observe(this._sentinel().nativeElement);
      this._destroyRef.onDestroy(() => observer.disconnect());
    });
  }

  protected selectedNodeLabel(node: FacetNode): string {
    if (node.type === FacetNodeType.EXTENDED) {
      const levelLabel = this.levelLabels[node.level] ?? node.level;
      return `${levelLabel}: ${node.label}`;
    }
    return node.value;
  }

  protected trackSelectedNode = (_: number, node: FacetNode): string =>
    node.type === FacetNodeType.EXTENDED ? node.id : node.value;
}
